import {
  RESERVATION_STATUS_LABELS,
  type ReservationStatus,
} from '@/modules/reservations/types';

const STATUS_CLASS: Record<ReservationStatus, string> = {
  draft: 'reservation-badge--draft',
  confirmed: 'reservation-badge--confirmed',
  in_progress: 'reservation-badge--in-progress',
  completed: 'reservation-badge--completed',
  cancelled: 'reservation-badge--cancelled',
};

type ReservationStatusBadgeProps = {
  status: ReservationStatus;
};

export function ReservationStatusBadge({ status }: ReservationStatusBadgeProps) {
  return (
    <span className={`reservation-badge ${STATUS_CLASS[status]}`}>
      {RESERVATION_STATUS_LABELS[status]}
    </span>
  );
}
